"use client";
import * as React from "react";
const SvgCheckOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m5.09 9.52-3.8-3.79L0 7.01l5.09 5.09L16 1.18 14.72-.1z" }));
export {
  SvgCheckOutlined as default
};
